import React from "react";
import { Routes, Route } from "react-router-dom";
import { TendersList } from "@/pages/Tenders/TendersList";
import { Opportunities } from "@/pages/Opportunities/Opportunities";
import { LegacyOpportunityRedirect } from "@/pages/Opportunities/LegacyOpportunityRedirect";

export const TendersRoutes: React.FC = () => {
    return (
        <Routes>
            <Route path="/" element={<Opportunities />} />
            <Route path="*" element={<LegacyOpportunityRedirect />} />
        </Routes>
    );
};

export { TendersList };
